import { Button } from '@hakimo-ui/shared/ui-base';
import { ClockIcon, PencilIcon } from '@heroicons/react/24/outline';
import { BADGE_CLASS } from '../../sop-workflow/util';
import {
  TimelineEntryViewProps,
  useTimelineEntryView,
} from './useTimelineEntryView';

export const BOX_CLASS =
  'border-onlight-line-2 dark:border-ondark-line-2 bg-onlight-bg-2 dark:bg-ondark-bg-2 rounded-lg border p-2';

export function DispatchTimelineEntryViewCompact({
  ev,
  pending: p,
  pendingFiles = [],
  timezone: tz,
  editDisabled,
  onEdit,
}: TimelineEntryViewProps) {
  const {
    effectiveType,
    dispTime,
    badgeLabel,
    effectiveComment,
    allSnapshotUrls,
    snapshotCount,
  } = useTimelineEntryView(ev, p, pendingFiles, tz);

  return (
    <div className="space-y-1">
      <div className="text-onlight-text-1 dark:text-ondark-text-1 flex h-5 items-center gap-1 text-sm font-medium">
        <ClockIcon className="h-3.5 w-3.5" />
        <span>{dispTime}</span>
        {!editDisabled && (
          <Button
            variant="icon"
            className="ml-auto shrink-0 !p-1"
            onClick={onEdit}
          >
            <PencilIcon className="text-onlight-text-2 dark:text-ondark-text-2 h-3.5 w-3.5" />
          </Button>
        )}
      </div>
      <div className="flex items-center">
        <span
          className={`shrink-0 rounded-full px-2 py-0.5 text-sm font-medium ${BADGE_CLASS[effectiveType]}`}
        >
          {badgeLabel}
        </span>
      </div>
      {(snapshotCount > 0 || !!effectiveComment) && (
        <div className="space-y-2 pt-1">
          {effectiveComment && (
            <div className={BOX_CLASS}>
              <p className="text-onlight-text-1 dark:text-ondark-text-1 text-sm">
                {`Comment: ${effectiveComment}`}
              </p>
            </div>
          )}
          {snapshotCount > 0 && (
            <div className={BOX_CLASS}>
              <div className="flex flex-wrap items-center gap-1.5">
                <span className="text-onlight-text-1 dark:text-ondark-text-1 mr-1 text-sm">
                  {snapshotCount} Snapshot{snapshotCount !== 1 && 's'}
                </span>
                {allSnapshotUrls.slice(0, 3).map((url, i) => (
                  <img
                    key={i}
                    src={url}
                    alt={`Snapshot ${i + 1}`}
                    className="h-10 w-14 rounded object-cover"
                  />
                ))}
                {snapshotCount > 3 && (
                  <span className="text-onlight-text-2 dark:text-ondark-text-2 text-xs">
                    +{snapshotCount - 3} more
                  </span>
                )}
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
}
